import { useContext } from "react";

import BookItemForm from "./BookItemForm";
import classes from "./BookItem.module.css";
import CartContext from "../../../store/cart-context";

const BookItem = (props) => {
  const cartCtx = useContext(CartContext);

  const addToCartHandler = (amount) => {
    cartCtx.addItem({
      id: props.id,
      name: props.name,
      amount: amount,
      price: props.price,
    });
  };

  const subjectsList = props.subjects.map((subject, index) => (
    <li key={index}>{subject}</li>
  ));


  return (
    // <li className={classes.book}>
    //   <div>
    //     <img src={props.image} alt="cover image" />
    //     <h3>{props.name}</h3>
    //     <div className={classes.description}>{props.description}</div>
    //     <div className={classes.price}>{props.price}</div>
    //   </div>
    //   <div>
    //     <BookItemForm id={props.id} onAddToCart={addToCartHandler} />
    //   </div>
    // </li>

    <li className={classes.book}>
    <div className={classes.content}>
      <div className={classes.image}>
        <img src={props.image} alt={props.name} />
      </div>
      <div className={classes.details}>
        <h3>{props.name}</h3>
        <div className={classes.description}>{props.description}</div>
        <ul className={classes.subjects}>{subjectsList}</ul>
        <div className={classes.price}>{`$${props.price}`}</div>
      </div>
    </div>
    <div>
      <BookItemForm id={props.id} onAddToCart={addToCartHandler} />
    </div>
  </li>
  );
};

export default BookItem;
